import { defineStore } from 'pinia'

import api from '../services/api' // ton service axios

import axios from 'axios'

import apiClient from '../services/axios'

import { CDNImage } from '../services/media/DecryptImage'



export const useAdminStore = defineStore('admin', {

  state: () => ({

    id: '',

    userName: '',

    role: '',

    avatar: '',

    code: '',

    parentId: '',

    iat: '',

  }),



  actions: {

    async getAdminAuthenticate() {

      // Check if this tab is an impersonation session

      const sessionData = sessionStorage.getItem('impersonation_session')

      if (sessionData) {

        try {

          const agent = JSON.parse(sessionData)

          // Try to fetch the real avatar for the impersonated agent

          let agentAvatarUrl = ''

          try {

            const impToken = sessionStorage.getItem('impersonation_token') || ''

            const { data: agentData } = await apiClient.post(api.getAuth(), {

              headers: { Authorization: `Bearer ${impToken}` },

            })

            // Search in admin/agent list for avatar

            const { data: admins } = await apiClient.post(api.listAdmins())

            const list = Array.isArray(admins) ? admins : (admins.data || [])

            const me = list.find((a: any) => a.username === (agentData.username || agent.username))

            if (me?.avatar && me.avatar.startsWith('http')) {

              const blob = await CDNImage(me.avatar)

              agentAvatarUrl = URL.createObjectURL(blob)

            }

          } catch {

            // Fallback: silent fail, will use dicebear

          }



          this.$state = {

            id: agent.id || '',

            userName: agent.username || '',

            role: agent.role || 'agent',

            avatar: agentAvatarUrl || `https://api.dicebear.com/9.x/adventurer/svg?seed=${agent.username}`,

            code: agent.code || '',

            parentId: agent.parent_id || '',

            iat: '',

          }

          return

        } catch {

          sessionStorage.removeItem('impersonation_session')

        }

      }



      // Récupérer le token selon le storage (sessionStorage pour agent, localStorage pour admin)

      const token = sessionStorage.getItem('admin_token') || localStorage.getItem('admin_token') || ''



      try {

        const { data } = await apiClient.post(api.getAuth(), {

          headers: { Authorization: `Bearer ${token}` },

        })



        // Fetch full admin profile to get avatar 

        let avatarUrl = ''

        try {

          const { data: admins } = await apiClient.post(api.listAdmins())

          const list = Array.isArray(admins) ? admins : (admins.data || [])

          const me = list.find((a: any) => a.username === data.username)

          if (me?.avatar && me.avatar.startsWith('http')) {

            const blob = await CDNImage(me.avatar)

            avatarUrl = URL.createObjectURL(blob)

          }

        } catch {


        }



        this.$state = {

          id: data.id,

          userName: data.username,

          role: data.role,

          avatar: avatarUrl || `https://api.dicebear.com/9.x/adventurer/svg?seed=${data.username}`,

          code: data.code,

          parentId: data.parent_id,

          iat: new Date(data.iat * 1000).toLocaleDateString('fr-FR'),

        }

      } catch (error) {

        console.error('Erreur authenticate admin :', error)

      }

    },

  },

})

